import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { Notice, OnboardingPage } from '../ui';
import actions from '../redux/actions';
import { OperationStatus } from '../types/OperationStatus';
import { UserRole } from '../types/UserRole';
import { UserStatus } from '../types/UserStatus';

const mapStateToProps = (state) => {
  return {
    registerVerificationStatus: state.registerVerificationStatus,
    loginStatus: state.loginStatus,
    loginToken: state.loginToken,
    user: state.user,
    device: state.resolution.device,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    verifyRegistration: (email, code) => dispatch(actions.verifyRegistration(email, code)),
    impersonate: (loginToken) => dispatch(actions.impersonate(loginToken)),
  };
};

class RegisterConfirm extends Component<any> {
  public state: any;

  constructor(props) {
    super(props);
    this.state = {
      accountType: '',
      email: '',
      code: '',
      verificationStatus: '',
    };
  }

  componentDidMount() {
    const url = new URL(window.location.href);
    const accountType = url.searchParams.get('accountType');
    const email = url.searchParams.get('email');
    const code = url.searchParams.get('code');

    this.setState({
      accountType,
      email,
      code,
    });

    if (
      this.props.user.role === UserRole.Anonymous ||
      this.props.user.status === UserStatus.EmailPending
    ) {
      if (email && code) {
        this.props.verifyRegistration(email, code);
      }
    } else {
      this.props.history.push('/account');
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.registerVerificationStatus.status !== prevProps.registerVerificationStatus.status
    ) {
      if (this.props.registerVerificationStatus.status === OperationStatus.success) {
        this.props.history.push('/register-approved');
        //this.props.impersonate(this.props.loginToken);
        return;
      }
    }

    if (this.props.loginStatus.status !== prevProps.loginStatus.status) {
      if (this.props.loginStatus.status === OperationStatus.success) {
        this.props.history.push('/complete-profile/personal');
      }
    }
  }

  render() {

    const isMobile = this.props.device === 'mobile' || this.props.device === 'mobile-tablet';

    //For FB/Google verification
    if (this.state.accountType === 'facebook' || this.state.accountType === 'google') {
      const provider = this.state.accountType === 'facebook' ? 'Facebook' : 'Google';
      return (
        <OnboardingPage title="Account created" isMobile={isMobile}>
          <Notice severity="success" title={`You ${provider} account verified successfully!`}>You can now login</Notice>
        </OnboardingPage>
      );
    }

    const email = this.state.email;
    const code = this.state.code;
    const status = this.props.registerVerificationStatus.status;
    const errorMessage = this.props.registerVerificationStatus.errorMessage;

    if (email && code) {
      return (
        <OnboardingPage title="Account verification" isMobile={isMobile}>
          {status === OperationStatus.notStarted && <Typography>...</Typography>}

          {status === OperationStatus.processing && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <CircularProgress size={24} />
              <Typography>Verifying...</Typography>
            </Box>
          )}

          {status === OperationStatus.fail && (
            <Notice severity="error" title="Unable to verify account">{errorMessage}</Notice>
          )}
        </OnboardingPage>
      );
    } else if (email) {
      return (
        <OnboardingPage title="Your email needs verification" isMobile={isMobile}>
          <Box>
            <Typography sx={{ mb: 1 }}>
              Verification email has been sent to <b>{email}</b>
            </Typography>
            <Typography>Please check your inbox and follow the link in the message</Typography>
            <Typography color="textSecondary">Double check your spam folder</Typography>
          </Box>
        </OnboardingPage>
      );
    } else {
      return null;
    }
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RegisterConfirm));
